export const DEBUG = process.env.NODE_ENV === "development";
